// extracted by mini-css-extract-plugin
export var actionButton = "_kh-t";
export var buttonContainer = "_kh-0";
export var buttonContainer2 = "_kh-1";
export var buttonSection = "_kh-2";
export var details = "_kh-3";
export var dropdownItem = "_kh-5";
export var dropdownItemsContainer = "_kh-4";
export var fileInput = "_kh-r";
export var headerButton = "_kh-6";
export var icon = "_kh-7";
export var input = "_kh-8";
export var macroListItem = "_kh-9";
export var mainContent = "_kh-a";
export var microText = "_kh-b";
export var modal = "_kh-w";
export var optionsButton = "_kh-c";
export var paperclip = "_kh-s";
export var pillContent = "_kh-d";
export var preview = "_kh-e";
export var preview2 = "_kh-f";
export var quillEditor = "_kh-q";
export var selectedMacro = "_kh-g";
export var sidebar = "_kh-h";
export var sidebarHeader = "_kh-j";
export var sidebarList = "_kh-i";
export var sidebarListItem = "_kh-k";
export var sidebarSearch = "_kh-l";
export var snoozeDurationWrapper = "_kh-v";
export var statusPillContainer = "_kh-m";
export var tagsContainer = "_kh-n";
export var unselectedMacro = "_kh-o";
export var variable = "_kh-u";
export var wrapper = "_kh-p";